<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加手机号</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="名称" required prop="name">
                <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="手机号" required prop="phone">
                <el-input v-model="addForm.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5,} from "@/common/Base64MD5";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

        deviceOWonCatCode:'',
        name:'',
        phone:'',

      },

      rules:{
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],

      }


    }
  },
  components: {

  },
  methods: {
    init(deviceOWonCatCode){
      this.$refs.addForm.resetFields();
      this.addForm.deviceOWonCatCode = deviceOWonCatCode;
    },
    closeSelf() {
      this.$emit("closeAddPhone");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceOWonCat/AddPhone",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAddPhone");
          this.$emit("getListPhone");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }
}


</script>





<style lang="scss" scoped>

</style>
